<template>
  <div v-if="disable">
    <slot></slot>
  </div>
  <v-tooltip v-else :color="color" transition="fade-transition" bottom>
    <template v-slot:activator="{ on }">
      <span :class="{ 'float-right': float }" v-on="on">
        <slot>
          <img
            src="@/assets/info.png"
            class="image"
            :class="{ inverted: isDarkMode }"
            style="max-height:13px"
          />
        </slot>
      </span>
    </template>
    <div v-if="text">{{ text }}</div>
    <template v-for="(line, index) in textList">
      <div :key="index">{{ line }}</div>
    </template>
  </v-tooltip>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    text: { type: String, default: null },
    textList: { type: Array, default: () => [] },
    float: { type: Boolean, default: false },
    color: { type: String, default: 'black' },
    disable: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters(['isDarkMode']),
  },
}
</script>

<style scoped>
.tooltip {
  height: 100%;
}

.image {
  opacity: 0.15;
  transition-property: opacity;
  transition-duration: 0.2s;
}

.image:hover {
  opacity: 1;
  transition-property: opacity;
  transition-duration: 0.2s;
}

.inverted {
  filter: invert(100%);
  opacity: 0.3;
}
</style>
